module.exports = __webpack_public_path__ + "static/image/company/m/image_value@3x.jpg?f1e91d1a";